// Add the -50% discount tag to the two cheapest bikes

function sortInputs(a, b) {
    return $(b).val() - $(a).val(); // Sort in descending order
}

const applyDiscount = function () {
    // Get the list of inputs that have a valid value
    // console.log("running discount");
    let listOfValueInputs = $("#questionsForm_bike-item-list .bike-value")
        .filter(function () {
            return !!this.value; // only return non empty inputs
        })
        .filter(function (input) { // only inputs that aren't errored
            return !$(input).hasClass("error");
        });
    if (listOfValueInputs < 2) return; 	// Only run the function if more than one input exists

    // Sort them by value order - descending
    let sortedList = listOfValueInputs.sort(sortInputs);
    // console.log(sortedList);
    // Remove the 'most-expensive' class from all inputs parent '.field__box'
    $(".field__box").removeClass("discounted");

    // Add the 'discounted' class to all but the dearest bike
    $.each(sortedList, function (i) {
        if (i !== 0) {
            $(sortedList[i]).parents(".field__box").addClass("discounted");
        }
    });
};

export default applyDiscount;